export default __webpack_public_path__ + "static/media/bg_light_green.3193b7b2.svg";